import { Stack, styled } from '@mui/material';

export const HeaderWrapper = styled(Stack)`
  width: 100%;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  max-width: 1620px;
`;

export const TextWrapper = styled(Stack)`
  align-items: start;
  height: 100%;
`;
